import { motion } from "framer-motion";

const TOPICS = [
  {
    num: "01",
    title: "building more than just followers",
    body: "there's a difference between posting just to go viral and building a platform around who God actually created you to be. let's talk about it.",
  },
  {
    num: "02",
    title: "what actually started moving the needle for my content",
    body: "i'll break down some of the biggest shifts i made that helped me stop just posting + start creating content that actually grew my audience.",
  },
  {
    num: "03",
    title: "how this became my actual life",
    body: "i want to take you behind the scenes of how i went from creating fitness content after my 9–5 to building an audience of hundreds of thousands + becoming a full-time creator.",
  },
];

export const Topics = () => (
  <section data-testid="topics-section" className="bg-cream">
    <div className="max-w-6xl mx-auto px-6 py-24">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="max-w-2xl"
      >
        <p className="font-accent text-2xl text-clay mb-3">here's the plan</p>
        <h2 data-testid="topics-title" className="font-heading text-4xl sm:text-5xl tracking-tight text-ink">
          What we'll talk about
        </h2>
      </motion.div>
      <div className="mt-12 grid md:grid-cols-3 gap-6">
        {TOPICS.map((t, i) => (
          <motion.div
            key={t.num}
            data-testid={`topic-card-${i + 1}`}
            className="rounded-2xl border border-line bg-white p-8 transition-shadow duration-300 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)]"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.12 }}
          >
            <span className="font-heading text-3xl text-clay">{t.num}</span>
            <h3 className="mt-4 font-heading text-2xl leading-snug text-ink">{t.title}</h3>
            <p className="mt-3 text-base text-stone-text leading-relaxed">{t.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
